import { formControlLabelClasses, switchClasses } from '@mui/material';
import { colorPalette } from '../../colorPalette';
export const formControlLabelStyles = {
    margin: 0,
    [`& .${formControlLabelClasses.label}`]: {
        color: colorPalette.gray900,
        lineHeight: '1.2621',
        marginLeft: '12px',
    },
    [`&.${formControlLabelClasses.labelPlacementStart}`]: {
        [`& .${formControlLabelClasses.label}`]: {
            marginLeft: 0,
            marginRight: '12px',
        },
    },
};
export const switchStyles = {
    height: 22,
    padding: 0,
    width: 40,
    [`& .${switchClasses.switchBase}`]: {
        margin: '1px 2px',
        padding: '2px',
        transform: 'translateX(0px)',
        transition: 'background-color 150ms ease-out, left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        [`&.${switchClasses.checked}`]: {
            transform: 'translateX(16px)',
            [`& + .${switchClasses.track}`]: {
                opacity: 1,
                backgroundColor: colorPalette.gray1000,
            },
            [`&.${switchClasses.disabled}`]: {
                '& > div': {
                    color: colorPalette.gray800,
                    backgroundColor: colorPalette.gray400,
                },
                [`& + .${switchClasses.track}`]: {
                    opacity: 1,
                    backgroundColor: colorPalette.gray600,
                },
            },
        },
        [`&.${switchClasses.disabled}`]: {
            cursor: 'not-allowed',
            pointerEvents: 'all',
            '& > div': {
                color: colorPalette.gray700,
                backgroundColor: colorPalette.gray100,
            },
            [`& + .${switchClasses.track}`]: {
                opacity: 1,
                backgroundColor: colorPalette.gray200,
            },
        },
        '&:hover': {
            backgroundColor: colorPalette.gray200,
            [`&.${switchClasses.checked}`]: {
                backgroundColor: colorPalette.gray900,
            },
        },
        '&:active': {
            '& > div': {
                borderRadius: '8px',
                transition: 'all 150ms ease-out',
                width: 20,
            },
            [`&.${switchClasses.checked}`]: {
                transform: 'translateX(12px)',
            },
        },
    },
    [`& .${switchClasses.track}`]: {
        backgroundColor: colorPalette.gray300,
        borderRadius: '16px',
        opacity: 1,
    },
};
export const switchIconStyles = {
    height: '12px',
    width: '12px',
};
export const switchThumbStyles = {
    alignItems: 'center',
    backgroundColor: colorPalette.white,
    borderRadius: '50%',
    color: colorPalette.gray1000,
    display: 'flex',
    height: 16,
    justifyContent: 'center',
    width: 16,
};
